// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__26QoW","label":"Radio_label__F70nc","checkMark":"Radio_checkMark__2J1_V","disabled":"Radio_disabled__1ASEe"};